export function seriesHasData(series, type, seriesId) {
  // @ts-ignore sankey is not in MIT version
  if (type === 'sankey') {
    return false;
  }
  const data = series[type]?.series[seriesId]?.data;
  return data != null && data.length > 0;
}